import styled from 'styled-components';
import CustomButton from '../UI/CustomButton/CustomButton';
import { ReactComponent as SuccessIcon } from '../../assets/check.svg';
import { PageContext } from '../../context/context';
import { useCallback, useContext } from 'react';
import { AlertKeys } from '../UI/Alert/Alert.types';

export function Success() {
    const { setAlert, successMessage } = useContext(PageContext);

    const handleClickBack = useCallback(() => {
        setAlert(AlertKeys.none);
    }, [setAlert]);

    return (
        <StyledSuccess>
            <StyledSuccessIcon />
            <h3>{successMessage}</h3>
            <p>
                Спасибо за ваше время. Мы будем рады видеть вас в нашей клинике
                вновь.
            </p>
            <CustomButton onClick={handleClickBack} type={'primary'}>
                Понятно
            </CustomButton>
        </StyledSuccess>
    );
}

const StyledSuccess = styled.div`
    padding: 56px 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    padding: 56px 80px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
    max-width: 490px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    @media (max-width: 768px) {
        max-width: 320px;
        gap: 16px;
        padding: 48px 15px;
    }
    h3 {
        font-size: 24px;
        font-weight: 700;
        padding: 0;
        margin: 0;
    }
    && p {
        font-size: 16px;
        font-weight: 400;
        padding: 0;
        margin: 0;
    }
    button {
        width: 100%;
    }
`;

const StyledSuccessIcon = styled(SuccessIcon)`
    width: 32px;
    height: 32px;
    margin-bottom: 16px;
`;
